<template>
    <el-card class="filter-container" shadow="never">
      <div class="filter-header">
        <div class="filter-title">
          <i class="el-icon-search"></i>
          <span>{{ title }}</span>
        </div>
        <div class="filter-actions">
          <el-button
            type="primary"
            @click="handleSearch"
            size="small">
            查询搜索
          </el-button>
          <el-button
            @click="handleReset"
            size="small">
            重置
          </el-button>
          <el-button
            v-if="isMobile && collapsible"
            @click="isCollapsed = !isCollapsed"
            type="text"
            class="collapse-btn">
            {{ isCollapsed ? '展开' : '收起' }}
            <i :class="['el-icon-arrow-down', { 'rotate-180': !isCollapsed }]"></i>
          </el-button>
        </div>
      </div>
      <div v-show="!isCollapsed" class="filter-content">
        <el-form 
          :inline="!isMobile" 
          :model="formData" 
          size="small" 
          :label-width="labelWidth"
          class="filter-form">
          <slot></slot>
        </el-form>
      </div>
    </el-card>
  </template>
  
  <script>
  export default {
    name: 'FilterBox',
    props: {
      title: {
        type: String,
        default: '筛选搜索'
      },
      formData: {
        type: Object,
        required: true
      },
      labelWidth: {
        type: String,
        default: '140px'
      },
      collapsible: {
        type: Boolean,
        default: true
      },
      defaultCollapsed: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        isCollapsed: this.defaultCollapsed,
        isMobile: false,
        lastWidth: 0
      }
    },
    mounted() {
      this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
      handleResize() {
        const newWidth = window.innerWidth;
        if (Math.abs(newWidth - this.lastWidth) > 50) {
          this.lastWidth = newWidth;
          this.checkMobile();
        }
      },
      checkMobile() {
        const wasMobile = this.isMobile;
        const newMobile = window.innerWidth < 768;
        this.isMobile = newMobile;

        if (wasMobile !== newMobile) {
          if (this.isMobile && this.collapsible) {
            this.isCollapsed = this.defaultCollapsed;
          } else {
            this.isCollapsed = false;
          }
        } else {
          if (!this.isMobile && this.isCollapsed === true) {
            this.isCollapsed = false;
          }
        }
      },
      handleSearch() {
        this.$emit('search', this.formData);
      },
      handleReset() {
        this.$emit('reset', this.formData);
      }
    }
  }
  </script>
  
  <style scoped>
  .filter-container {
    margin-bottom: 20px;
  }
  
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .filter-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
  }
  
  .filter-title i {
    margin-right: 8px;
  }
  
  .filter-actions {
    display: flex;
    align-items: center;
  }
  
  .filter-actions .el-button {
    margin-left: 10px;
  }
  
  .collapse-btn i {
    transition: transform 0.3s;
    margin-left: 4px;
  }
  
  .rotate-180 {
    transform: rotate(180deg);
  }
  
  .filter-content {
    margin-top: 15px;
  }
  
  .filter-form {
    display: flex;
    flex-wrap: wrap;
  }
  
  /* 移动端适配 */
  @media screen and (max-width: 768px) {
    .filter-header {
      padding-bottom: 10px;
    }
    
    .filter-title {
      margin-bottom: 10px;
    }
    
    .filter-actions {
      width: 100%;
      justify-content: flex-end;
      margin-top: 5px;
    }
    
    .filter-actions .el-button {
      margin-left: 8px;
      margin-right: 0;
    }
    
    .filter-form ::v-deep .el-form-item {
      width: 100%;
      margin-right: 0;
      margin-bottom: 15px;
      display: flex;
      flex-direction: column;
    }
    
    .filter-form ::v-deep .el-form-item__label {
      text-align: left;
      margin-bottom: 5px;
      width: 100% !important;
    }
    
    .filter-form ::v-deep .el-form-item__content {
      width: 100%;
      margin-left: 0 !important;
    }
    
    .filter-form ::v-deep .el-input,
    .filter-form ::v-deep .el-select,
    .filter-form ::v-deep .el-date-editor {
      width: 100%;
    }
    
    .collapse-btn {
      padding: 0;
      margin-left: 15px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/layout/FilterBox.vue